"use client";
import { Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledSkeleton = styled(Skeleton)`
    &.MuiSkeleton-root::after {
        animation: wave 2s linear 0.5s 2;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(0, 0, 0, 0.1),
            transparent
        );
    }

    @keyframes wave {
        0% {
            transform: translateX(-100%);
        }
        60% {
            transform: translateX(100%);
        }
        100% {
            transform: translateX(100%);
        }
    }

    @media (prefers-reduced-motion) {
        &.MuiSkeleton-root::after {
            animation: none;
        }
    }
`;
export {
  StyledSkeleton
};
